import agent from 'superagent';
import defaults from 'superagent-defaults';
import promise from 'superagent-promise';

const client = defaults(promise(agent, Promise));

export default {
  all: function() {
    return client.get(`${process.env.S3_ASSETS_URL}/banners/banners.json`)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/bannersAPI.js